/* eslint-disable react-hooks/exhaustive-deps */
import { Grid, Rating } from "@mui/material";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import API from "@unisearch/helpers/api";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import styles from "./guest_form_review.module.scss";
import { swalSuccess } from "@unisearch/helpers";
import { useRecoilValue } from "recoil";
import { authAtom } from "@_recoil/_state";
import Link from "next/link";
import { useSystemActions } from "@_recoil/_actions";
import { useRouter } from "next/router";

const init = {
  universityId: undefined,
  rating: undefined,
  reviewerType: "registered",
  reviewComment: "",
};

const RegisterFormReview = ({
  uniProfileData,
  setModal,
  getData,
  onEdit,
  existingComment,
  getComment,
}) => {
  const router = useRouter();
  const { asPath } = router;
  const profileInfo = useRecoilValue(authAtom);
  const [formData, setFormData] = useState(init);
  const systemActions = useSystemActions();

  useEffect(() => {
    if (onEdit) {
      setFormData({
        universityId: parseInt(existingComment?.universityId),
        rating: parseInt(existingComment?.rating),
        reviewerType: "registered",
        reviewComment: existingComment?.reviewComment,
      });
    } else {
      setFormData(init);
    }
  }, [onEdit, existingComment]);

  useEffect(() => {
    systemActions.removeReturnUrl();
  }, []);

  // validation schema
  const validationSchema = Yup.object().shape({
    rating: Yup.number().required("Field is required"),
    reviewComment: Yup.string().required("Field is required"),
  });

  const handleSubmitForm = async (values) => {
    const payload = {
      universityId: uniProfileData?.universityId,
      rating: values.rating,
      reviewerType: "registered",
      reviewerId: profileInfo.id,
      reviewComment: values.reviewComment,

      // reviewerName: `${profileInfo.firstName} ${profileInfo.middleName} ${profileInfo.lastName}`,
      // reviewerEmail: profileInfo.email,
      // reviewerPhone: profileInfo.mobile,
      // reviewerCountryId: profileInfo.countryId,
    };

    if (onEdit) {
      await API.patch(
        `/public/university-review/${existingComment?.universityReviewId}`,
        payload
      ).then(async (res) => {
        if (!res.error) {
          swalSuccess("Updated");
          setModal(false);
          await getData();
          await getComment();
          router.push(asPath);
        }
      });
    } else {
      await API.post("/public/university-review", payload).then(async (res) => {
        if (!res.error) {
          swalSuccess("Submitted");
          setModal(false);
          await getData();
          await getComment();
        }
      });
    }
  };

  const getSign = async () => {
    systemActions.setReturnUrl(router.asPath);
    await router.push({ pathname: "/signin" });
  };

  return (
    <div className={styles.wrapper}>
      {profileInfo ? (
        <Formik
          initialValues={formData}
          enableReinitialize={true}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            handleSubmitForm(values);
          }}
        >
          {({ handleSubmit, setFieldValue, values, errors, touched }) => (
            <Form className="form">
              <div className={styles.rating_wrapper}>
                <Rating
                  sx={{ fontSize: "50px", mt: 3 }}
                  value={parseInt(values.rating)}
                  name="rating"
                  onChange={(event, newValue) => {
                    setFieldValue("rating", newValue);
                  }}
                />
                {errors.rating && touched.rating && (
                  <div className="invalid-feedback frontend">
                    {errors.rating}
                  </div>
                )}
              </div>
              <Grid container spacing={4}>
                <Grid item md={12} sm={12} xs={12}>
                  <div className={styles.text_input_wrapper}>
                    <label>Write your review</label>
                    <textarea
                      style={{ resize: "vertical" }}
                      name="reviewComment"
                      onChange={(e) => {
                        setFieldValue("reviewComment", e.target.value);
                      }}
                      value={values.reviewComment}
                      type="text"
                      placeholder="Write Here"
                    />
                  </div>
                  {errors.reviewComment && touched.reviewComment && (
                    <span className="invalid-feedback frontend">
                      {errors.reviewComment}
                    </span>
                  )}
                </Grid>
                <Grid item sm={12}>
                  <div className={styles.action_btn}>
                    <button
                      onClick={() => handleSubmit}
                      type="submit"
                      className="btn btn-secondary btn-md"
                    >
                      {onEdit ? "Update Review" : "Submit Review"}
                    </button>
                  </div>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      ) : (
        <button
          style={{ width: "100%", marginTop: "20px" }}
          onClick={getSign}
          className="btn btn-secondary btn-bg"
        >
          Sign in
        </button>
      )}
    </div>
  );
};

export default RegisterFormReview;
